import Footer from './components/CommonComps/Footer';
import Header from './components/CommonComps/Header';
import Home from './pages/Home';

function App() {
  return (
    <main className="font-playfair">
      <Header />
      <Home />
      <Footer />
    </main>
  );
}

export default App;
